import { render, staticRenderFns } from "./SelectModuleButton.vue?vue&type=template&id=376bf57c&scoped=true&"
import script from "./SelectModuleButton.vue?vue&type=script&lang=js&"
export * from "./SelectModuleButton.vue?vue&type=script&lang=js&"
import style0 from "./SelectModuleButton.vue?vue&type=style&index=0&id=376bf57c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376bf57c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('376bf57c')) {
      api.createRecord('376bf57c', component.options)
    } else {
      api.reload('376bf57c', component.options)
    }
    module.hot.accept("./SelectModuleButton.vue?vue&type=template&id=376bf57c&scoped=true&", function () {
      api.rerender('376bf57c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/SelectModule/SelectModuleModal/components/common/SelectModuleButton.vue"
export default component.exports